const { GLOBAL_LOCALES } = require('@rsc/gatsby-localization-helpers');

const allowedLanguages = [GLOBAL_LOCALES.English.id];

function showDownloadsList(locale) {
  return allowedLanguages.includes(locale);
}

module.exports = {
  showDownloadsList,
};
